import React from 'react';
import moment from 'moment';

function GetRanksDate(rank, eagleinfo) {
    if (rank.name == 'Eagle Scout' && eagleinfo && eagleinfo.eagleBoardReviewDate) {
        return moment(eagleinfo.eagleBoardReviewDate).format('MM/DD/YYYY');
    } else {
        const earnedDate = rank.dateEarned || rank.effectiveDt;
        return earnedDate ? moment(earnedDate).format('MM/DD/YYYY') : '';
    }
}

export default GetRanksDate;


// WEBPACK FOOTER //
// ./src/components/Inc/GetRanksDate.js